var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUploaderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.429,
    height: 34.429,
    viewBox: "0 0 34.429 34.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-image-368879",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M98.8,59.631h27.24a3.617,3.617,0,0,0,3.594-3.594V28.8a3.617,3.617,0,0,0-3.594-3.594H98.8A3.617,3.617,0,0,0,95.2,28.8v27.24A3.617,3.617,0,0,0,98.8,59.631Zm.643-30.191h25.916v16.95l-5.3-5.3a.776.776,0,0,0-1.1,0l-3.935,3.9L108.3,38.217a.776.776,0,0,0-1.1,0l-7.756,7.756ZM112.987,35a2.989,2.989,0,1,1,2.989,2.989A2.971,2.971,0,0,1,112.987,35Z",
    transform: "translate(-95.205 -25.202)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploaderIcon);
export default __webpack_public_path__ + "static/media/file_uploader_icon.5c8fbbc93602716521dd548fa8296106.svg";
export { ForwardRef as ReactComponent };